import React, { useRef, useEffect, useState } from "react";
import "./FullWidthMedia.css";
import { useVideoManager } from "../context/VideoManager";

const FullWidthMedia = ({
  media,
  userInteracted,
  paddingLeft = 0,
  paddingRight = 0,
}) => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [volume, setVolume] = useState(0);
  let hasUserInteracted = userInteracted;

  const { handleVideoUnmute } = useVideoManager();
  
    const handleMuteToggle = (videoRef) => {
      if (videoRef) {
        const isMuted = videoRef.muted;
        if (!isMuted) {
          handleVideoUnmute(videoRef); // Notify VideoManager
        }
        videoRef.muted = !isMuted; // Toggle mute state
      }
    };

  useEffect(() => {
    if (videoRef.current) {
      if (media.type === "video") {
        videoRef.current.muted = true; // Set audio to off

        // Add scroll event listener
        window.addEventListener(
          "scroll",
          fullWidthMediaHandleScrollMediaComponents
        );

        // Add mouseover event listener
        videoRef.current.addEventListener("mouseover", () => {
          setShowControls(true);
        });

        // Add mouseout event listener
        videoRef.current.addEventListener("mouseout", () => {
          setShowControls(false);
        });
      }
    }

    // Add an event listener to the video element to set the flag when the user interacts with it
    window.addEventListener("click", () => {
      hasUserInteracted = true;
    });

    return () => {
      // Remove scroll event listener on unmount
      if (media.type === "video") {
        window.removeEventListener(
          "scroll",
          fullWidthMediaHandleScrollMediaComponents
        );
      }
    };
  }, [videoRef, media]);

  const fullWidthMediaHandleScrollMediaComponents = () => {
    if (media.type === "video") {
      const videoRect = videoRef.current.getBoundingClientRect();
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const videoMiddle = window.scrollY + videoRect.top + videoRect.height / 2;

      console.log(
        `Scroll position: ${scrollPosition}, videoMiddle: ${videoMiddle}`
      );
      console.log(`Video rect: ${videoRect}`);

      if (
        scrollPosition < videoMiddle - videoRect.height * 0.85 ||
        scrollPosition > videoMiddle + videoRect.height * 0.85
      ) {
        console.log("Video is not fully visible, pausing");
        if (videoRef.current !== null && !videoRef.current.paused) {
          videoRef.current.pause();
        }
      } else {
        console.log("Video is fully visible, playing");
        if (videoRef.current !== null && videoRef.current.paused) {
          if (hasUserInteracted) {
            videoRef.current.play();
          }
        }
      }
    }
  };

  // const fullWidthMediaHandleScrollMediaComponents = () => {
  //   if (media.type === "video") {
  //     const videoRect = videoRef.current.getBoundingClientRect();
  //     const scrollPosition = window.scrollY + window.innerHeight / 2;

  //     console.log(
  //       `Scroll position: ${scrollPosition}, videoRect: ${JSON.stringify(videoRect)}`
  //     );

  //     // Check if video is not sufficiently visible
  //     if (
  //       scrollPosition < videoRect.top + videoRect.height * 0.5 || // Top 3/4 out of view
  //       scrollPosition > videoRect.bottom - videoRect.height * 0.5 // Bottom 3/4 out of view
  //     ) {
  //       console.log("fullWidthMediaHandleScrollMediaComponents: Video is not sufficiently visible, pausing");
  //       console.log("fullWidthMediaHandleScrollMediaComponents: Scroll Possition: ", scrollPosition)
  //       console.log("fullWidthMediaHandleScrollMediaComponents: videoReact.Top + videoReact.height * 0.10", videoRect.top + videoRect.height * 0.10)
  //       console.log("fullWidthMediaHandleScrollMediaComponents: videoReact.Bottom + videoReact.height * 0.10", videoRect.bottom - videoRect.height * 0.10)

  //       if (videoRef.current && !videoRef.current.paused) {
  //         videoRef.current.pause();
  //       }
  //     } else {
  //       console.log("fullWidthMediaHandleScrollMediaComponents: Video is sufficiently visible, playing");
  //       console.log("fullWidthMediaHandleScrollMediaComponents: Video is not sufficiently visible, pausing");
  //       console.log("fullWidthMediaHandleScrollMediaComponents: Scroll Possition: ", scrollPosition)
  //       console.log("fullWidthMediaHandleScrollMediaComponents: videoReact.Top + videoReact.height * 0.10", videoRect.top + videoRect.height * 0.10)
  //       console.log("fullWidthMediaHandleScrollMediaComponents: videoReact.Bottom + videoReact.height * 0.10", videoRect.bottom - videoRect.height * 0.10)

  //       if (videoRef.current && videoRef.current.paused) {
  //         if (hasUserInteracted) {
  //           videoRef.current.play();
  //         }
  //       }
  //     }
  //   }
  // };

  const handleUnmute = () => {
    console.log("Unmute button clicked");
    setMuted(!muted); // Unmute video
  };

  const fadeInAudio = () => {
    const audio = videoRef.current;
    audio.volume = 0;
    setVolume(0);
    const intervalId = setInterval(() => {
      if (audio.volume < 1) {
        const newVolume = Math.min(audio.volume + 0.1, 1);
        audio.volume = newVolume;
        setVolume(newVolume);
      } else {
        clearInterval(intervalId);
      }
    }, 500);
  };

  const fadeOutAudio = () => {
    const audio = videoRef.current;
    audio.volume = 1;
    setVolume(1);
    const intervalId = setInterval(() => {
      if (audio.volume > 0) {
        const newVolume = Math.max(audio.volume - 0.1, 0);
        audio.volume = newVolume;
        setVolume(newVolume);
      } else {
        clearInterval(intervalId);
      }
    }, 500);
  };

  let mediaElement;
  if (media.type === "image") {
    mediaElement = <img ref={videoRef} src={media.src} alt={media.alt} />;
  } else if (media.type === "video") {
    mediaElement = (
      <div className="full-width-video-container">
        <video
          className="full-width-video"
          playsInline
          webkit-playsinline="true"
          preload="metadata"
          ref={videoRef}
          src={media.src}
          loop
          muted={muted}
          volume={volume}
          controls={showControls}
          onClick={(e) => handleMuteToggle(e.target)}
          onError={(e) => console.error("Video error:", e.target.error)}
          onLoadedMetadata={() => {
            if (!isPlaying) {
              videoRef.current.play();
              setIsPlaying(true);
            }
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingLeft: `${paddingLeft}px`,
        paddingRight: `${paddingRight}px`,
      }}
    >
      {mediaElement}
    </div>
  );
};

export default FullWidthMedia;
